/**
 * External dependencies
 */
import React, { Component } from 'react';
import classNames from 'classnames';
import { Box } from '@towersystems/towersystems-design-system';

import './styles.scss';

/**
 * Internal dependencies
 */
class Topbar extends Component {
	render() {
		const { children, className, ...rest } = this.props;
		const classes = classNames('topbar', className);
		return (
			<Box className={classes} padding='xlarge' {...rest}>
				<Box className='topbar__inner'>{children}</Box>
			</Box>
		);
	}
}
export default Topbar;
